import { render, staticRenderFns } from "./ontick-switch.component.bkp.vue?vue&type=template&id=7387709c&scoped=true"
import script from "./ontick-switch.component.bkp.vue?vue&type=script&lang=js"
export * from "./ontick-switch.component.bkp.vue?vue&type=script&lang=js"
import style0 from "./ontick-switch.component.bkp.vue?vue&type=style&index=0&id=7387709c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387709c",
  null
  
)

export default component.exports